import React, { Component } from 'react'
import cloneDeep from 'lodash/cloneDeep';
import Dropdown from '../components/Dropdown'
import Modal from '../components/Modal'
import Input from '../components/Input'
import { LanguageContext, LanguageConsumer } from '../lib/LanguageContext'
import Autocomplete from '../components/Autocomplete'
import './Filters.css'

const EnrollmentStatusDateType = [
  {
    'id': 'period',
  }, {
    'id': 'single',
  }
]

const EnrollmentTermType = [
  {
    'id': 'period',
  }, {
    'id': 'single',
  }
]

class Filters extends Component {

  constructor(props) {
    super(props)
    this.state = {
      filters: cloneDeep(this.props.filters),
      dropdowns : {
        severityGroup: false,
        enrollmentStatusDateType: false
      },
      autocompletes: {
        enrollmentType: false,
        enrollmentStatus: false,
        accountType: false
      }
    }
  }

  selectorToggle = (selector) => {
      let selections = this.state.filters.selections
      let chosenId = selections.findIndex(sel => sel.id === selector.id)
      selections[chosenId] = {...selections[chosenId], active: !selector.active}
      this.props.handleDropdown(!selector.active)
      this.setState({selections})
  }

  selectorOpen = (selector) => {
     let selections = this.state.filters.selections
      let chosenId = selections.findIndex(sel => sel.id === selector.id)
      selections[chosenId] = {...selector, active: true}
      this.props.handleDropdown(true)
      this.setState({selections})
  }

  selectorClose = (selector) => {
      let selections = this.state.filters.selections
      let chosenId = selections.findIndex(sel => sel.id === selector.id)
      selections[chosenId] = {...selector, active: false}
      this.props.handleDropdown(false)
      this.setState({selections})
  }

  selectionHandleChange = (active, category) => {
        let selections = this.state.filters.selections
        let availableSelections =  category.availableSelections
        let selected = category.selected
        let queryStr = ''
        let availableSelectionsLen = availableSelections.length - 1
        let activeIndex = selected.indexOf(active)
        let selectedLen
        if(activeIndex > -1) {
            selected.splice(activeIndex, 1)
        } else {
            selected.push(active)
        }
        activeIndex = selected.indexOf(active)
        let allActiveIndex = selected.indexOf('all')
        if(active === 'all') {
            selected = activeIndex > -1 ? availableSelections.map(sel => sel.id) : []
            selectedLen = activeIndex > -1 ? availableSelectionsLen : 0
        } else {
            if(activeIndex < 0 && allActiveIndex > -1) {
                selected.splice(allActiveIndex, 1)
            }
            selectedLen = selected.length
            if(selectedLen === availableSelectionsLen) {
                selected.push('all')
            }
        }
        if(selectedLen !== 0 && selectedLen !== availableSelectionsLen) {
            selected.map(value => {
                if(queryStr.length === 0) {
                    queryStr = `${value}`
                } else {
                    queryStr += `,${value}`
                }
            })
        } else {
            queryStr = (selectedLen === availableSelectionsLen) ? 'all' : ''
            allActiveIndex  = (selectedLen === availableSelectionsLen) ? true : false
        }
        let chosenCategoryIndex = selections.findIndex(sel => sel.id === category.id)
        selections[chosenCategoryIndex] = {...category, selected,  queryStr}
        this.setState({selections})
  }

  handleChange = (name, value) => {
    let filters = this.state.filters
    filters.fields[name] = value
    if(name === 'enrollmentTermFrom' || name === 'enrollmentTermTo') {
      let substituteField = 'enrollmentTerm'
      filters.fields[substituteField] = ''
    } else if(name === 'enrollmentTerm') {
      let substituteFields = ['enrollmentTermFrom', 'enrollmentTermTo']
      filters.fields[substituteFields[0]] = filters.fields[substituteFields[1]] = ''
    }
    this.setState({filters})
  }

  handleDateChange = (name, value) => {
    let filters = this.state.filters
    let joinedVersion = this.props.fieldPairs[name]
    filters.fields[name] = this.formatDate(value)
    filters.fields[joinedVersion] = value.replace(/-/g, '')
    if(value.length) {
      if(name === 'enrollmentStatusDateFrom' || name === 'enrollmentStatusDateFrom') {
        let substituteField = 'enrollmentStatusDate'
        let substituteJoinedVersion = this.props.fieldPairs[substituteField]
        filters.fields[substituteField] = filters.fields[substituteJoinedVersion] = ''
      } else if(name === 'enrollmentStatusDate') {
        let substituteFields = ['enrollmentStatusDateFrom', 'enrollmentStatusDateTo']
        let substituteJoinedVersions = [this.props.fieldPairs[substituteFields[0]], this.props.fieldPairs[substituteFields[1]]]
        filters.fields[substituteFields[0]] = filters.fields[substituteJoinedVersions[0]] = ''
        filters.fields[substituteFields[1]] = filters.fields[substituteJoinedVersions[1]] = ''
      }
    }
    this.setState({filters})
  }

  changeEnrollmentStatusDateType = (active) => {
    let filters = this.state.filters
    filters.enrollmentStatusDateType = active.id
    this.setState({filters})
    this.dropdownClose('enrollmentStatusDateType')
  }

  changeEnrollmentTermType = (active) => {
    let filters = this.state.filters
    filters.enrollmentTermType = active.id
    this.setState({filters})
    this.dropdownClose('enrollmentTermType')
  }

  dropdownHandleChange = (name, value) => {
    this.handleChange(name, value)
    this.dropdownClose(name)
  }

  dropdownToggle = (name) => {
    let dropdowns = this.state.dropdowns
    let active = dropdowns[name]
    dropdowns[name] = !active
    this.setState({dropdowns})
  }

  dropdownOpen = (name) => {
    let dropdowns = this.state.dropdowns
    dropdowns[name] = true
    this.setState({dropdowns})
  }

  dropdownClose = (name) => {
    let dropdowns = this.state.dropdowns
    dropdowns[name] = false
    this.setState({dropdowns})
  }

  autocompleteToggle = (name, active) => {
    let autocompletes = this.state.autocompletes
    autocompletes[name] = active
    this.setState({autocompletes})
  }

  keyDown = (e) => {
    if(e.key === 'Escape') {
      this.cancelFilters()
    } else if(e.key === 'Enter'){
      this.setFilters()
    }
  }

  formatDate = (date) => {
    let newDate = ''
    if(/^[\d-]+$/.test(date)) {
      if(date.length >= 5) {
        if(date.charAt(4) !== '-') {
          newDate = date.substr(0, 4) + '-' + date.substr(4, date.length)
        } else {
          newDate = date
        }
      }
      if(date.length >= 8) {
        if(newDate.charAt(7) !== '-') {
          newDate = newDate.substr(0, 7) +  '-' + newDate.substr(7, date.length)
        } else {
          newDate = newDate
        }
      }
    }
    newDate = newDate.length === 0 ? date : newDate
    return newDate
  }

  enrollmentTypeChange = (value) => this.setState({enrollmentType: value})

  cancelFilters = () => {
    this.props.onRequestClose()
    this.setState({filters: cloneDeep(this.props.filters)})
  }

  setFilters = () => {
    let filters = this.state.filters
    let fields = filters.fields
    Object.keys(fields).map(field => fields[field] = fields[field] !== 'all' ? fields[field] : '')
    filters = {...filters, fields}
    this.props.setFilters(cloneDeep(filters))
    this.props.onRequestClose()
  }

  openModal = () => {
    let name = this.props.fieldToEdit.name
    let selector = this.props.fieldToEdit.selector
    if(name) {
      let input = document.querySelector(`input[name='${name}']`)
      input.focus()
    }
  }

  componentDidUpdate = (nextProps) => {
    if(nextProps.filters !== this.props.filters) {
       this.setState({filters: cloneDeep(this.props.filters)})
    }
  }

  componentDidMount = () => {
    document.addEventListener("keydown", this.keyDown, false)
  }

  componentWillMount = () => {
    document.removeEventListener("keydown", this.keyDown, false)
  }

  render = () => {
   let fieldCategory = this.state.filters.selections.find(sel => sel.id === 'fields')
   let errorTypeCategory = this.state.filters.selections.find(sel => sel.id === 'errorTypes')
   let errorCodeCategory = this.state.filters.selections.find(sel => sel.id === 'errorCodes')
   let severityGroup = this.state.filters.fields.severityGroup
   severityGroup = severityGroup ? severityGroup : 'all'
   let departmentID = this.state.filters.fields.departmentID
   departmentID = departmentID ? departmentID : 'all'

   let enrollmentStatusDateType = EnrollmentStatusDateType.map(type => ({...type, display: this.context.polyglot.t(`Dropdown.enrollmentStatusDateType.${type.id}`)}))
   let enrollmentTermType = EnrollmentTermType.map(type => ({...type, display: this.context.polyglot.t(`Dropdown.enrollmentTermType.${type.id}`)}))

    return (
     <LanguageConsumer>
      {({polyglot}) => 
        (<div>
            <Modal
              isOpen={this.props.filtersModalIsOpen}
              onAfterOpen={this.openModal}
              onRequestClose={this.cancelFilters}
              className= 'scroll-modal'
              contentLabel="Example Modal">
              <div className='search-header'>
                <div className="closeModal" onClick={this.cancelFilters}>
                  <div id='x-icon'>
                      <span />
                      <span />
                      <span />
                      <span />
                  </div>
                </div>
              </div>
              <div className='search-filters'>
                  <h1 className='filters-header'><span className='fas fa-sliders-h'></span> {polyglot.t('Checks.filters')}</h1>
                  <div className='error-filters filter-group'>
                      <div className='header'>
                        <h3><span className='fas fa-exclamation-triangle'></span> {polyglot.t('Checks.errorFilters')}</h3>
                      </div>
                      <Dropdown display={polyglot.t(`Dropdown.${fieldCategory.id}.label`)}
                                name={fieldCategory.id}
                                handleChange={(active) => this.selectionHandleChange(active, fieldCategory)}
                                type='multiple-select'
                                list={fieldCategory.availableSelections}
                                activeList={fieldCategory.selected}
                                active={fieldCategory.active}
                                toggle={() => this.selectorToggle(fieldCategory)}
                                open={() => this.selectorOpen(fieldCategory)}
                                close={() => this.selectorClose(fieldCategory)}
                                selection={polyglot.t(`Dropdown.${fieldCategory.id}.label`)}
                                explanation
                                translate/>
                      <Dropdown display={polyglot.t(`Dropdown.${errorTypeCategory.id}.label`)}
                                name={errorTypeCategory.id}
                                handleChange={(active) => this.selectionHandleChange(active, errorTypeCategory)}
                                type='multiple-select'
                                list={errorTypeCategory.availableSelections}
                                activeList={errorTypeCategory.selected}
                                active={errorTypeCategory.active}
                                toggle={() => this.selectorToggle(errorTypeCategory)}
                                open={() => this.selectorOpen(errorTypeCategory)}
                                close={() => this.selectorClose(errorTypeCategory)}
                                selection={polyglot.t(`Dropdown.${errorTypeCategory.id}.label`)}
                                translate/>
                      <Dropdown label={polyglot.t(`Dropdown.severityGroup.label`)}
                                name="severityGroup"
                                handleChange={(active, name) => this.dropdownHandleChange(name, active.id)}
                                type='single-select'
                                list={this.props.severityGroupList}
                                active={this.state.dropdowns.severityGroup}
                                toggle={(name) => this.dropdownToggle(name)}
                                open={(name) => this.dropdownOpen(name)}
                                close={(name) => this.dropdownClose(name)}
                                activeId={severityGroup}
                                selection={polyglot.t(`Dropdown.severityGroup.label`)}
                                translate />
                      <Dropdown display={polyglot.t(`Dropdown.${errorCodeCategory.id}.label`)}
                                name={errorCodeCategory.id}
                                handleChange={(active) => this.selectionHandleChange(active, errorCodeCategory)}
                                type='multiple-select'
                                list={errorCodeCategory.availableSelections}
                                activeList={errorCodeCategory.selected}
                                active={errorCodeCategory.active}
                                toggle={() => this.selectorToggle(errorCodeCategory)}
                                open={() => this.selectorOpen(errorCodeCategory)}
                                close={() => this.selectorClose(errorCodeCategory)}
                                selection={polyglot.t(`Dropdown.${errorCodeCategory.id}.label`)}
                                />
                  </div>
                  <div className='student-filters filter-group'>
                      <div className='header'>
                        <h3><span className='fas fa-user'></span> {polyglot.t('Checks.studentFilters')}</h3>
                      </div>
                      <div className='filter-group'>
                          <div className='header'>
                            <h4> {polyglot.t('Checks.identifiers')}</h4> 
                          </div>
                          <Input type='text' name='registrationID' label={polyglot.t('Filters.registrationID')} value={this.state.filters.fields.registrationID} onChange={this.handleChange}/>
                          <Input type='text' name='systemID' label={polyglot.t('Filters.systemID')} value={this.state.filters.fields.systemID} onChange={this.handleChange}/>
                          <Input type='text' name='ssn' label={polyglot.t('Filters.ssn')} value={this.state.filters.fields.ssn} onChange={this.handleChange}/>
                          <Input type='text' name='ssnCountry' label={polyglot.t('Filters.ssnCountry')} value={this.state.filters.fields.ssnCountry} onChange={this.handleChange}/>
                          <Input type='text' name='tin' label={polyglot.t('Filters.tin')} value={this.state.filters.fields.tin} onChange={this.handleChange}/>
                          <Input type='text' name='tinCountry' label={polyglot.t('Filters.tinCountry')} value={this.state.filters.fields.tinCountry} onChange={this.handleChange}/>
                      </div>
                      <div className='filter-group'>
                          <div className='header'>
                              <h4> {polyglot.t('Checks.names')}</h4>
                          </div>
                          <Input type='text' name='lastNameEl' label={polyglot.t('Filters.lastNameEl')} value={this.state.filters.fields.lastNameEl} onChange={this.handleChange}/>
                          <Input type='text' name='lastNameEn' label={polyglot.t('Filters.lastNameEn')} value={this.state.filters.fields.lastNameEn} onChange={this.handleChange}/>
                          <Input type='text' name='firstNameEl' label={polyglot.t('Filters.firstNameEl')} value={this.state.filters.fields.firstNameEl} onChange={this.handleChange}/>
                          <Input type='text' name='firstNameEn' label={polyglot.t('Filters.firstNameEn')} value={this.state.filters.fields.firstNameEn} onChange={this.handleChange}/>
                          <Input type='text' name='fatherFirstNameEl' label={polyglot.t('Filters.fatherFirstNameEl')} value={this.state.filters.fields.fatherFirstNameEl} onChange={this.handleChange}/>
                          <Input type='text' name='fatherFirstNameEn' label={polyglot.t('Filters.fatherFirstNameEn')} value={this.state.filters.fields.fatherFirstNameEn} onChange={this.handleChange}/>
                          <Input type='text' name='motherFirstNameEl' label={polyglot.t('Filters.motherFirstNameEl')} value={this.state.filters.fields.motherFirstNameEl} onChange={this.handleChange}/>
                          <Input type='text' name='motherFirstNameEn' label={polyglot.t('Filters.motherFirstNameEn')} value={this.state.filters.fields.motherFirstNameEn} onChange={this.handleChange}/>
                      </div>
                      <div className='filter-group'>
                          <div className='header'>
                              <h4> {polyglot.t('Checks.studies')}</h4>
                          </div>
                          <Dropdown label={polyglot.t(`Dropdown.department.label`)}
                                    name="departmentID"
                                    handleChange={(active, name) => this.dropdownHandleChange(name, active.id)}
                                    type='single-select'
                                    list={this.props.departmentList}
                                    active={this.state.dropdowns.departmentID}
                                    toggle={(name) => this.dropdownToggle(name)}
                                    open={(name) => this.dropdownOpen(name)}
                                    close={(name) => this.dropdownClose(name)}
                                    activeId={departmentID}
                                    selection={polyglot.t(`Dropdown.department.label`)}
                                    translate />
                          <Autocomplete type='text' name='enrollmentType' label={polyglot.t('Filters.enrollmentType')} value={this.state.filters.fields.enrollmentType} list={this.props.enrollmentTypeList} active={this.state.autocompletes.enrollmentType} onChange={this.handleChange} open={(name) => this.autocompleteToggle(name, true)} close={(name) => this.autocompleteToggle(name, false)}/>

                          <Autocomplete type='text' name='enrollmentStatus' label={polyglot.t('Filters.enrollmentStatus')} value={this.state.filters.fields.enrollmentStatus} list={this.props.enrollmentStatusList} active={this.state.autocompletes.enrollmentStatus} onChange={this.handleChange} open={(name) => this.autocompleteToggle(name, true)} close={(name) => this.autocompleteToggle(name, false)}/>
                         <div className='filters-category'>
                           <h3>{polyglot.t('Filters.enrollmentTerm')}</h3>
                           <Dropdown className='inline borderless labeless'
                                       label=''
                                       name="enrollmentTermType" handleChange={(active) => this.changeEnrollmentTermType(active)}
                                       type='single-select'
                                       list={enrollmentTermType}
                                       active={this.state.dropdowns.enrollmentTermType}
                                       toggle={(name) => this.dropdownToggle(name)}
                                       open={(name) => this.dropdownOpen(name)}
                                       close={(name) => this.dropdownClose(name)}
                                       activeId={this.state.filters.enrollmentTermType}
                                       selection=''
                                       translate/>
                            {this.state.filters.enrollmentTermType === 'period' ? (
                              <div>
                                <Input type='text' name='enrollmentTermFrom' label={polyglot.t('Filters.enrollmentTermFrom')} value={this.state.filters.fields.enrollmentTermFrom} onChange={this.handleChange}/>
                                <Input type='text' name='enrollmentTermTo' label={polyglot.t('Filters.enrollmentTermTo')} value={this.state.filters.fields.enrollmentTermTo} onChange={this.handleChange}/>
                              </div>) : (
                               <div>
                                <Input className='smaller-font' type='text' name='enrollmentTerm' label={polyglot.t('Filters.enrollmentTerm')} value={this.state.filters.fields.enrollmentTerm} onChange={this.handleChange}/>
                              </div>)
                            }
                         </div>
                         <div className='filters-category'>
                             <h3>{polyglot.t('Filters.enrollmentStatusDate')}</h3>
                             <Dropdown className='inline borderless labeless'
                                       label=''
                                       name="enrollmentStatusDateType" handleChange={(active) => this.changeEnrollmentStatusDateType(active)}
                                       type='single-select'
                                       list={enrollmentStatusDateType}
                                       active={this.state.dropdowns.enrollmentStatusDateType}
                                       toggle={(name) => this.dropdownToggle(name)}
                                       open={(name) => this.dropdownOpen(name)}
                                       close={(name) => this.dropdownClose(name)}
                                       activeId={this.state.filters.enrollmentStatusDateType}
                                       selection=''
                                       translate/>
                             {this.state.filters.enrollmentStatusDateType === 'period' ? (
                               <div>
                                 <Input className='smaller-font' type='text' name='enrollmentStatusDateFrom' label={polyglot.t('Filters.enrollmentStatusDateFrom')} value={this.state.filters.fields.enrollmentStatusDateFrom} placeholder='YYYY-MM-DD' onChange={this.handleDateChange}/>
                                 <Input className='smaller-font' type='text' name='enrollmentStatusDateTo' label={polyglot.t('Filters.enrollmentStatusDateTo')} value={this.state.filters.fields.enrollmentStatusDateTo} placeholder='YYYY-MM-DD' onChange={this.handleDateChange}/>
                               </div>) : (
                              <div>
                                 <Input className='smaller-font' type='text' name='enrollmentStatusDate' label={polyglot.t('Filters.enrollmentStatusDate')} value={this.state.filters.fields.enrollmentStatusDate} placeholder='YYYY-MM-DD' onChange={this.handleDateChange}/>
                              </div>)
                               }
                           </div>
                      </div>
                      <div className='filter-group'>
                          <div className='header'>
                              <h4> {polyglot.t('Checks.account')}</h4>
                          </div>
                          <Input type='text' name='loginName' label={polyglot.t('Filters.loginName')} value={this.state.filters.fields.loginName} onChange={this.handleChange}/>
                         <Autocomplete type='text' name='accountStatus' label={polyglot.t('Filters.accountStatus')} value={this.state.filters.fields.accountStatus} list={this.props.accountStatusList} active={this.state.autocompletes.accountStatus} onChange={this.handleChange} open={(name) => this.autocompleteToggle(name, true)} close={(name) => this.autocompleteToggle(name, false)}/>
                      </div>
                      <div className='filter-group'>
                        <div className='header'>
                              <h4> {polyglot.t('Checks.contact')}</h4>
                        </div>
                          <Input type='text' name='extEmail' label={polyglot.t('Filters.extEmail')} value={this.state.filters.fields.extEmail} onChange={this.handleChange}/>
                          <Input type='text' name='mobilePhone' label={polyglot.t('Filters.mobilePhone')} value={this.state.filters.fields.mobilePhone} onChange={this.handleChange}/>
                      </div>
                      <div className='filter-group'>
                          <div className='header'>
                              <h4> {polyglot.t('Checks.personalInfo')}</h4>
                          </div>
                          <Input type='text' name='birthDate' label={polyglot.t('Filters.birthDate')} value={this.state.filters.fields.birthDate} placeholder='YYYY-MM-DD' onChange={this.handleDateChange}/>
                          <Input type='text' name='birthYear' label={polyglot.t('Filters.birthYear')} value={this.state.filters.fields.birthYear} placeholder='YYYY' onChange={this.handleChange}/>
                          <Input type='text' name='gender' label={polyglot.t('Filters.gender')} value={this.state.filters.fields.gender} onChange={this.handleChange}/>
                          <Input type='text' name='citizenship' label={polyglot.t('Filters.citizenship')} value={this.state.filters.fields.citizenship} onChange={this.handleChange}/>
                      </div>
                  </div>
                  <div className='search-footer'>
                    <button className='cancel-button' onClick={this.cancelFilters}>
                      {polyglot.t('Checks.cancel')}
                    </button>
                    <button className='continue-button' onClick={this.setFilters}>
                      {polyglot.t('Checks.continue')}
                    </button>
                  </div>
              </div>
          </Modal>
        </div>)}
      </LanguageConsumer>
    )
  }
}
Filters.contextType = LanguageContext

export default Filters



// WEBPACK FOOTER //
// ./src/results/Filters.js